// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"44f2f1b1","455":"f7f84d97","977":"d0736737"}[chunkId] + ".chunk.js";
};